import { ReactElement } from 'react'

import { usePermissions } from '@/hooks/usePermissions'

import { Box, HStack, Spacer, Text, Tooltip } from '@chakra-ui/react'

import { LabeledSwitch } from '../../components/LabeledSwitch'

interface DryRunToggleIProps {
  isDryRun: boolean
  onDryRunToggle: () => void
  isLoading?: boolean
}

export const DryRunToggle = ({
  isDryRun,
  onDryRunToggle,
  isLoading = false,
}: DryRunToggleIProps): ReactElement => {
  const { isImplementer } = usePermissions()
  const isDisabledByPermissions = !isImplementer
  const isSwitchDisabled = isLoading || isDisabledByPermissions
  const shouldShowPermissionTooltip = isDisabledByPermissions && !isLoading

  return (
    <Box>
      <HStack>
        <Box>
          <Text
            fontSize='16px'
            fontWeight='medium'
            letterSpacing='-0.8px'
            mb={2}
          >
            Enable Dry Run
          </Text>
          <Text color='gray.600' fontSize='sm' mb={4}>
            Run the AI Operator without acting on incidents to evaluate
            performance
          </Text>
        </Box>
        <Spacer />
        <Tooltip
          isDisabled={!shouldShowPermissionTooltip}
          label='You do not have the appropriate permissions to update this setting'
          shouldWrapChildren
        >
          <Box>
            <LabeledSwitch
              id='dryRunToggle'
              isChecked={isDryRun}
              isDisabled={isSwitchDisabled}
              onSwitchChange={onDryRunToggle}
            />
          </Box>
        </Tooltip>
      </HStack>
    </Box>
  )
}
